import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
const CTASection = ({ onOpenContactForm, heading, paragraph, buttonText }) => {
  const section = useScrollAnimation({ threshold: 0.2 });
  return (
    <section data-testid="cta-section" ref={section.ref} className="py-14 md:py-24 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-32 h-1 bg-[#6366F1]" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className={`grid lg:grid-cols-12 gap-8 items-center scroll-fade-up ${section.isVisible?'scroll-visible':''}`}>
          <div className="lg:col-span-8">
            <h2 className="text-2xl sm:text-4xl font-semibold tracking-tight text-white mb-3" style={{fontFamily:"'Playfair Display',serif"}}>{heading}</h2>
            <p className="text-base font-normal text-white/80 leading-relaxed max-w-lg">{paragraph}</p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Button data-testid="cta-section-button" onClick={onOpenContactForm} className="bg-white text-[#6366F1] hover:bg-white/90 font-semibold px-8 py-5 text-sm rounded-full">
              {buttonText} <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CTASection;
